import { Button, Container, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import Box from '@mui/material/Box'
import { SuccessMessage } from './styles'
import { passwordResetEmail } from '../../../../utils/Firebase/methods'
import { handleFirebaseAuthError } from '../../../../utils/Firebase/errorHandler'

export default function PasswordRecoveryForm({ navigate }) {
	const [email, setEmail] = useState('')
	const [error, setError] = useState('')
	const [hideInput, setHideInput] = useState(false)

	const handleRecovery = async (e) => {
		e.preventDefault()
		setError('')
		try {
			await passwordResetEmail(email)
			setHideInput(true)
		} catch (error) {
			const userFriendlyMessage = handleFirebaseAuthError(error)
			setError(userFriendlyMessage)
			console.error('Password recovery failed:', error)
		}
	}

	return (
		<Container component="main" maxWidth="xs">
			<Box component="form" onSubmit={handleRecovery} sx={{ mt: 1 }}>
				{hideInput && (
					<SuccessMessage>
						If the email address you entered is registered with us, you will receive a password recovery
						email shortly. Please follow the instructions in the email to reset your password.
					</SuccessMessage>
				)}
				{!hideInput && (
					<>
						<TextField
							type="email"
							variant="outlined"
							margin="normal"
							required
							fullWidth
							label="Email Address"
							autoComplete="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
						<Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
							Send Email
						</Button>
					</>
				)}
				{error && (
					<Typography color="error" sx={{ mb: 2, textAlign: 'center' }}>
						{error}
					</Typography>
				)}
				<Button onClick={navigate} fullWidth color="primary">
					Back
				</Button>
			</Box>
		</Container>
	)
}
